export const environment = {
  production: false,
  firebase_local: {
    apiKey: "AIzaSyCq9HJ7JG8nROs_ru2rqrN37NkIf14QF3A",
    authDomain: "prueba-realtime-31966.firebaseapp.com",
    databaseURL: "https://prueba-realtime-31966-default-rtdb.firebaseio.com",
    projectId: "prueba-realtime-31966",
    storageBucket: "prueba-realtime-31966.appspot.com",
    messagingSenderId: "56766133434",
    appId: "1:56766133434:web:ef20b57d1650466c4efe83",
    measurementId: "G-28JWYDHLKE"
  },
  firebase: {
    apiKey: "AIzaSyAMfQYSi8NV6pYz9n2qgrZHOaaI1L9dE7I",
    authDomain: "prodooh-fb42f.firebaseapp.com",
    databaseURL: "https://prodooh-fb42f-default-rtdb.firebaseio.com",
    projectId: "prodooh-fb42f",
    storageBucket: "prodooh-fb42f.appspot.com",
    messagingSenderId: "595380961783",
    appId: "1:595380961783:web:412307eaf502d156e52ef2",
    measurementId: "G-GLH7JHCS67"
  },
  endpoints: {
    login: 'https://api-staging.prodooh.com/oauth/token',
    services: 'https://api-staging.prodooh.com',
    users_imgs: 'https://api-staging.prodooh.com/img/users',
    screens_imgs: 'https://api.prodooh.com/img/screens',
    companies_imgs: 'https://api-staging.prodooh.com/img/companies',
    user_upload_img: 'https://api-staging.prodooh.com/users/upload/image',
    screen_upload_img: 'https://api-staging.prodooh.com/screens/image/upload',
    report_upload_img: 'https://api-staging.prodooh.com/campaigns/report/image',
    company_upload_img: 'https://api-staging.prodooh.com/companies/upload/image',
    creatives_imgs: 'https://api-staging.prodooh.com/img/screen_creatives',
    pdfs_temporary: 'https://api-staging.prodooh.com/pdfs/temporary',
    excels_temporary: 'https://api-staging.prodooh.com/excels/temporary',
    upload_files_particular_points: 'https://api-staging.prodooh.com/particular-points-interest/upload',
    files_particular_points: 'https://api-staging.prodooh.com/files/temporary',
    base_files: 'https://api-staging.prodooh.com/files',
    kmlKmzUpload: 'https://api-staging.prodooh.com/mapping-file/upload',
    kmlKmzFiles: 'https://api-staging.prodooh.com/files/kml_kmz',
    uploadImpactsFiles: 'https://api-staging.prodooh.com/impacts/upload',
    uploadImpactsReportFiles: 'https://api-staging.prodooh.com/impacts-report/upload',
    uploudFiles: 'https://api-staging.prodooh.com/file-manager/upload',
    audienceReportUploadFile: 'https://api-staging.prodooh.com/audience-report-uploads/upload',
    audienceReportUploadDeleteFile: 'https://api-staging.prodooh.com/audience-report-uploads/delete-file',
    audienceReportUploadsCreate: 'https://api-staging.prodooh.com/audience-report-uploads',
    photographicWitnesses: 'https://api-staging.prodooh.com/campaigns/witnesses/upload/image',
    witnessesAdManager: 'https://api-staging.prodooh.com/campaigns/witnesses/upload/reports',
    witnesses_imgs: 'https://api-staging.prodooh.com/img/witnesses',
    temporary_witnesses_zip: 'https://api-staging.prodooh.com/files/temporary/zips',
    download_witnesses_imgs: 'https://api-staging.prodooh.com/public/download/img',
    media_content_upload_img: 'https://api-staging.prodooh.com/media-content/upload/image',
    media_contents_imgs: 'https://api-staging.prodooh.com/img/media_contents',
    temporary_files: 'https://api-staging.prodooh.com/files/temporary',
    img_reports: 'https://api-staging.prodooh.com',
    upload_report_ad_circuit: 'https://api-staging.prodooh.com/campaigns/ads/report/upload',
    company_upload_img_portada: 'https://api-staging.prodooh.com/companies/upload/image-portada',
    pdf_portada: 'https://api-staging.prodooh.com/img/portadas',
    country_promotions: 'https://api-staging.prodooh.com/countries/upload/promotions',
    pdf_promotions: 'https://api-staging.prodooh.com/pdfs/promotions/',
    screen_template: 'https://api-staging.prodooh.com/screen-template/upload-file',
    monitor_witnesses: 'https://api-staging.prodooh.com/img/monitor/witnesses',
    fm_public_base: 'https://staging-files.prodooh.com'
  }
};
